<template>
  <div>
    <div class="x-banner">
      <!-- banner -->
      <BANNER></BANNER>
      <!-- 二级导航 -->
      <NAVIGATION
        :data="navigationData"
        :currentPath="currentPath"
      ></NAVIGATION>
    </div>
    <div class="container-width location">
      当前位置:<router-link to="/">首页</router-link> >
      <router-link to="/jyzn">就医指南</router-link> >
      <router-link to="/jyzn/luxian">乘车路线</router-link>
    </div>

    <div class="container-width x-article">
      <div class="title">乘车路线</div>
      <div v-for="(item, index) in list" :key="index" class="l-content">
        <div class="list">
          {{ item.title }}
        </div>
        <div class="description" v-html="item.description"></div>
      </div>
    </div>
    <div class="container-width mb50">
      <div class="dmcx">
        <div class="fr">
          <div
            id="allmap"
            style="overflow: hidden; zoom: 1; position: relative"
          >
            <div
              id="map"
              style="
                height: 100%;
                -webkit-transition: all 0.5s ease-in-out;
                transition: all 0.5s ease-in-out;
              "
            ></div>
          </div>
        </div>
        <div class="lf" id="lf_id">
          <h3>中国医科大学附属盛京医院院区分布</h3>
          <div id="lf_div">
            <ul>
              <li class xy="123.432914,41.778433">
                <a>
                  <h4>盛京医院南湖院区</h4>
                  <div class="bt">
                    <p>地址：中国辽宁省沈阳市和平区三好街36号</p>
                  </div>
                </a>
              </li>
              <li class xy="123.368958,41.779765">
                <a>
                  <h4>盛京医院滑翔院区</h4>
                  <div class="bt">
                    <p>地址：中国辽宁省沈阳市铁西区滑翔路39号</p>
                  </div>
                </a>
              </li>
              <li class xy="123.410506,41.95097">
                <a>
                  <h4>盛京医院沈北院区</h4>
                  <div class="bt">
                    <p>地址：中国辽宁省沈阳市沈北新区蒲河大道16号</p>
                  </div>
                </a>
              </li>
              <li class xy="123.675138,41.516503">
                <a>
                  <h4>科技创新中心</h4>
                  <div class="bt">
                    <p>地址：中国辽宁省本溪经济开发区木兰路7号</p>
                  </div>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import service from "../../service/jyzn";
import BANNER from "../../components/banner/jyzn";

export default {
  name: "LUXIAN",
  data() {
    return {
      navigationData: [
        {
          name: "就医须知",
          path: "/jyzn",
        },
        {
          name: "门诊就诊流程图",
          path: "/jyzn/liucheng",
        },
        {
          name: "楼层分布",
          path: "/jyzn/fenbu",
        },
        {
          name: "乘车路线",
          path: "/jyzn/luxian",
        },
        {
          name: "联系我们",
          path: "/jyzn/lianxi",
        },
      ],
      currentPath: "/jyzn/luxian",
      pageIndex: 1,
      pageSize: 1000,
      totalPages: 1,
      currentPage: 1,
      list: {},
      total: 0,
    };
  },
  components: {
    BANNER,
  },
  computed: {},
  created() {
    this.init();
  },
  beforeMount() {},
  methods: {
    init() {
      let parmes = {};
      service.getBusList(parmes, (res) => {
        this.list = res.content || [];
      });
    },
  },
  mounted() {
    //去掉a的虚框
    $("#lf_id a").bind("focus", function () {
      this.blur();
    });
    // 百度地图API功能
    var point = new Array();
    var marker = new Array();
    var map = new BMap.Map("map");
    var poi = new BMap.Point(123.432914, 41.778433); //城市坐标123.388035,41.815184
    var content = "";
    for (let po = 0; po < $("#lf_id li").length; po++) {
      point[po] = $("#lf_id li").eq(po).attr("xy"); //每个店面的坐标
    }
    //地图初始化
    map.centerAndZoom(poi, 12);
    map.enableScrollWheelZoom();
    map.addControl(new BMap.NavigationControl());
    map.addControl(
      new BMap.OverviewMapControl({
        isOpen: true,
        anchor: BMAP_ANCHOR_BOTTOM_RIGHT,
      })
    ); //右上角，打开
    //创建检索信息窗口对象
    var searchInfoWindow = null;

    searchInfoWindow = new BMapLib.SearchInfoWindow(map, content, {
      title: "", //标题
      width: 270, //宽度
      height: 80, //高度
      panel: "panel", //检索结果面板
      enableAutoPan: true, //自动平移
      searchTypes: [
        BMAPLIB_TAB_SEARCH, //周边检索
        BMAPLIB_TAB_TO_HERE, //到这里去
        BMAPLIB_TAB_FROM_HERE, //从这里出发
      ],
    });
    //为地图添加坐标打点
    for (let m = 0; m < $("#lf_id li").length; m++) {
      marker[m] = new BMap.Marker(
        new BMap.Point(point[m].split(",")[0], point[m].split(",")[1])
      );
      map.addOverlay(marker[m]);
    }
    //map.removeOverlay(marker);
    var xy_sp;
    $(function () {
      //点击左侧列表
      $("#lf_id li").mouseenter(function () {
        $("#lf_id li").removeClass("active");
        $(this).addClass("active");
        var xy_sp = $(this).index();
        map.addOverlay(marker[xy_sp]); //在地图中添加marker
        searchInfoWindow.open(marker[xy_sp]); //在marker上打开检索信息串口
        searchInfoWindow.setTitle($(this).find("h4").text()); //弹出层标题
        searchInfoWindow.setContent($(this).find(".bt").text()); //弹出层内容
      });
      //点击地图的点
      $(".BMap_Marker").bind("click", function () {
        var this_id = $("#lf_id li").eq($(this).index());
        var xy_sp = $(this).index();
        map.addOverlay(marker[xy_sp]); //在地图中添加marker
        searchInfoWindow.open(marker[xy_sp]); //在marker上打开检索信息串口
        searchInfoWindow.setTitle(this_id.find("h4").text()); //弹出层标题
        searchInfoWindow.setContent(this_id.find(".bt").text()); //弹出层内容
      });
    });
  },
  watch: {},
};
</script>

<style lang="scss" scoped>
.x-article {
  -webkit-transition: all 0.5s ease 0s;
  -moz-transition: all 0.5s ease 0s;
  transition: all 0.5s ease 0s;
  box-shadow: 4px 4px #ececec;
  margin-bottom: 50px;
  border: 1px solid #ebebeb;
  border-top: none;
  box-sizing: border-box;

  .title {
    padding-top: 30px;
    padding-bottom: 30px;
    font-weight: bold;
    text-align: center;
    border-bottom: 1px solid #ebebeb;
    font-size: 1.4rem;
  }
  .l-content {
    padding: 0 50px 50px 50px;
    .list {
      margin-top: 50px;
      font-size: 1.2rem;
      background: #00479d;
      color: #fff;
      cursor: pointer;
      height: 60px;
      line-height: 60px;
      padding-left: 10px;
    }
    .description {
      font-size: 1.2rem;
      line-height: 40px;
    }
  }
}
@media only screen and (max-width: 720px) {
  .x-article {
    .l-content {
      padding: 0 5px 5px 5px;
      .list {
        font-size: 0.95rem;
      }
      .description {
        font-size: 1rem;
        line-height: 1.3rem;
      }
    }
  }
}
</style>
